import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { StorageHelper } from '../../../utils/StorageHelper';
import { useAppStore } from '../../../store/AppContext';
import { BackMappings } from '../../../utils/BackMappings';

interface Props {
  hittype: string;
  event_category: string;
  event_action: string;
  event_label: string;
}

const WaMenuOroLink: FC<Props> = (props) => {
  const { event_action, event_category, event_label, hittype } = props;
  const dataApp = useAppStore();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { access, lang } = dataApp;
  const APP_BASE_URL = document.location.hostname.includes('eroski.es')
    ? process.env.REACT_APP_BASE_URL
    : process.env.REACT_APP_BASE_URL_CAPRABO;

  return (
    <>
      <div className="icon-link-block">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          data-wa-hittype={hittype}
          data-wa-event-category={event_category}
          data-wa-event-action={event_action}
          data-wa-event-label={event_label}
          href=""
          onClick={(e) => {
            StorageHelper.loadOroDataEvent(
              BackMappings.TARJETA_MENU_ORO,
              '',
              t('tarjetas.hazte-oro.request-gold-card'),
            );
            StorageHelper.deleteUserFromSessionAndRedirect(
              access.solicitarTarjeta,
              lang,
              APP_BASE_URL,
              e,
              '',
              navigate,
            );
          }}
          className="icon-link icon-link__oro"
        >
          <img src={access.solicitarTarjeta?.urlImagen} alt="" />
          <span>{access.solicitarTarjeta?.descripcion}</span>
        </a>
      </div>
    </>
  );
};
export default WaMenuOroLink;
